import { render, staticRenderFns } from "./MainNavigation.vue?vue&type=template&id=644d663d&scoped=true"
import script from "./MainNavigation.vue?vue&type=script&lang=ts"
export * from "./MainNavigation.vue?vue&type=script&lang=ts"
import style0 from "./MainNavigation.vue?vue&type=style&index=0&id=644d663d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d663d",
  null
  
)

export default component.exports